











import { Component, Vue, Prop } from "vue-property-decorator";
import { Toast } from "vant";

@Component
export default class PartLoading extends Vue {
  private created() {
      console.log(123);
  }
}
